@use '@/scss/underscore' as _;

.container {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .cardTitle {
    flex-shrink: 0;
    margin-bottom: _.unit(4);
  }
}

.betaNotice {
  // Show multiple spaces
  white-space: pre-wrap;
  margin-bottom: _.unit(4);
}
